"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageAspectRatio = exports.getImageEncoding = exports.getEditImageRequestStatus = exports.getImageWidth = exports.getImageHeight = exports.getFolderId = exports.getFileToEditName = exports.getFileToEditId = exports.getImageSrc = exports.getSelectedImageFrom = exports.getSelectedImageToEdit = void 0;

var getSelectedImageToEdit = function getSelectedImageToEdit(state) {
  return state.editAndCreateImage.get('imgToEditSelected');
};

exports.getSelectedImageToEdit = getSelectedImageToEdit;

var getSelectedImageFrom = function getSelectedImageFrom(state) {
  return state.editAndCreateImage.get('selectedImgFrom');
};

exports.getSelectedImageFrom = getSelectedImageFrom;

var getImageSrc = function getImageSrc(state) {
  return state.editAndCreateImage.get('imgSrc');
};

exports.getImageSrc = getImageSrc;

var getFileToEditId = function getFileToEditId(state) {
  return state.editAndCreateImage.get('fileId');
};

exports.getFileToEditId = getFileToEditId;

var getFileToEditName = function getFileToEditName(state) {
  return state.editAndCreateImage.get('fileName');
};

exports.getFileToEditName = getFileToEditName;

var getFolderId = function getFolderId(state) {
  return state.editAndCreateImage.get('fileFolderId');
};

exports.getFolderId = getFolderId;

var getImageHeight = function getImageHeight(state) {
  return state.editAndCreateImage.get('imgHeight');
};

exports.getImageHeight = getImageHeight;

var getImageWidth = function getImageWidth(state) {
  return state.editAndCreateImage.get('imgWidth');
};

exports.getImageWidth = getImageWidth;

var getEditImageRequestStatus = function getEditImageRequestStatus(state) {
  return state.editAndCreateImage.get('updateRequestStatus');
};

exports.getEditImageRequestStatus = getEditImageRequestStatus;

var getImageEncoding = function getImageEncoding(state) {
  return state.editAndCreateImage.get('encoding');
};

exports.getImageEncoding = getImageEncoding;

var getImageAspectRatio = function getImageAspectRatio(state) {
  return getImageWidth(state) / getImageHeight(state);
};

exports.getImageAspectRatio = getImageAspectRatio;